import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {ApiProvider} from "../api/api";
import {UserStateProvider} from "../user-state/user-state";

/*
  Generated class for the UserTagProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class UserTagProvider {

  tags: Map<string, string>

  constructor(private api: ApiProvider, private userState: UserStateProvider) {
    this.tags = new Map<string, string>();

  }



  getValue(ref: string) {
    if(this.tags && this.tags.has(ref)) {
      return this.tags.get(ref);
    }
  }

  compile(text: string, optionalOverwrites: any): string {
    if(!text) {
      return text;
    }
    if(optionalOverwrites) {
      for(var k in optionalOverwrites) {
        text = text.replace('{'+k+'}', optionalOverwrites[k]);
      }
    }

    var iterator1 = Array.from(this.tags[Symbol.iterator]());
    for(let l of iterator1) {
      l[1] = l[1].replace('<br>', '').trim();
      if(l[1]) {
        text = text.replace('{'+l[0]+'}', l[1]);
      }
    }
    text = text.replace('{name}', this.userState.user.firstName);
    text = text.replace('&nbsp;', ' ');
    return text;
  }

  saveChanges(values: any) {
    for(let k in values) {
      this.tags.set(k, values[k].toString());
    }
    this.api.callPut<any>('/users/'+this.userState.user.id+'/tags', values).subscribe();
    console.log(values, this.tags);
  }

  loadTags(tags: any) {
    for(let k in tags) {
      this.tags.set(k, tags[k]);
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/user-tag/user-tag.ts